import { updates } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-8">
          更新快讯
        </h2>
        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300 -translate-x-1/2 hidden md:block"></div>
          <div className="space-y-6">
            {updates.map((item, i) => (
              <div
                key={i}
                className={`relative flex flex-col md:flex-row gap-3 md:gap-8 ${
                  i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                <div className="flex-1 md:text-right hidden md:block">
                  {i % 2 === 0 && (
                    <span className="text-xs text-foreground-400">{item.date}</span>
                  )}
                </div>
                <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100 z-10 mt-1"></div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1 md:hidden">
                    <span className="text-xs text-foreground-400">{item.date}</span>
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                      item.tag === '热播' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '上新' ? 'bg-accent-100 text-accent-700' :
                      item.tag === '活动' ? 'bg-secondary-100 text-secondary-700' :
                      'bg-background-200 text-foreground-600'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <div className="bg-background-50 rounded-lg p-4">
                    <div className="hidden md:flex items-center gap-2 mb-1">
                      <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                        item.tag === '热播' ? 'bg-primary-100 text-primary-700' :
                        item.tag === '上新' ? 'bg-accent-100 text-accent-700' :
                        item.tag === '活动' ? 'bg-secondary-100 text-secondary-700' :
                        'bg-background-200 text-foreground-600'
                      }`}>
                        {item.tag}
                      </span>
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed">{item.title}</p>
                  </div>
                </div>
                <div className="flex-1 hidden md:block">
                  {i % 2 !== 0 && (
                    <span className="text-xs text-foreground-400">{item.date}</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}